// "Make evidence point" under a condition photo (block 8, piece 10): keeps this
// photo's place and direction on its area's entry in the register, so later
// visits retake the same view. Only once the job is won (its areas are in the
// register) and the photo is uploaded; needs signal.
import { useState } from 'react';
import { Button } from '@higgins/ui';
import { ApiError, isConnectionFailure, makeEvidencePointApi } from '../lib/api';
import { takeServerChange, type DeviceRecord } from '../lib/device-db';

function describe(err: unknown): string {
  if (isConnectionFailure(err)) return 'Making an evidence point needs signal.';
  if (err instanceof ApiError) return err.message;
  return 'The evidence point wasn’t made. Try again.';
}

export function EvidencePointButton({ row }: { row: DeviceRecord }) {
  const [busy, setBusy] = useState(false);
  const [problem, setProblem] = useState<string | null>(null);
  if (typeof row.fields.hig_evidencepointid === 'string') return <p className="text-xs text-slate-600">An evidence point: later visits retake this view.</p>;

  async function make() {
    setBusy(true);
    setProblem(null);
    try {
      const made = await makeEvidencePointApi(row.id);
      await takeServerChange(row.id, { hig_evidencepointid: made.pointId }, made.etag);
    } catch (err) {
      setProblem(describe(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex flex-wrap items-center gap-2">
      <Button variant="outline" size="sm" className="min-h-11" disabled={busy || typeof row.fields.hig_driveitemid !== 'string'} onClick={() => void make()}>
        Make evidence point
      </Button>
      <span className="text-xs text-slate-500">{typeof row.fields.hig_driveitemid === 'string' ? 'Later visits retake this view from the same spot.' : 'Once the photo has uploaded.'}</span>
      {problem && <p className="w-full text-sm text-red-700">{problem}</p>}
    </div>
  );
}
